import { Buffer } from 'buffer';

/*
  Calculates the memory size of input JSON data.
  Useful especially for debugging memory leaks
*/

function getStringSize(json) {
  const size = Buffer.byteLength(json);
  const kbs = size / 1024;
  const mbs = kbs / 1024;

  return { mbs, kbs };
}

export default getStringSize;
